import { camelToKebab as r } from "./highrise506.mjs";
const a = (o) => {
  const e = {};
  for (const n in o)
    e[`--n-${r(n)}`] = o[n];
  return e;
};
export {
  a as JSONtoNaiveVars
};
